import React, { useState, useEffect } from "react";
import { useForm } from "@mantine/form";
import Profile from "./Pages/Profile";
import useUserStore from "../../stores/userStore";

export default function ProfilePage() {
  const [isEditMode, setIsEditMode] = useState(false);
  const { user, setUser } = useUserStore((state) => state);

  // Create form with initial values
  const form = useForm({
    initialValues: {
      avatar: null,
      first_name: user.user.first_name || "",
      last_name: user.user.last_name || "",
      user_type: user.user.user_type || 0,
      company: user.user.company || "",
      job_title: user.user.job_title || "",
      year_of_experience: user.user.year_of_experience || 0,
      work_type: user.user.work_type || "",
      university: user.user.university || "",
      degree: user.user.degree || "",
      country: user.user.address?.country || "",
      city: user.user.address?.city || "",
      about_me: user.user.about_me || "",
      expert_in: user.user.expert_in || [],
      skills: user.user.skills || [],
      industries: user.user.industries || [],
      github: user.user.github || "",
      twitter: user.user.twitter || "",
      linkedin: user.user.linkedin || "",
      public_email: user.user.public_email || "",
      public_phone: user.user.public_phone || "",
      display_email: user.user.display_email,
      display_phone: user.user.display_phone,
    },
    validate: {},
  });

  // Update form values when user data changes
  useEffect(() => {
    console.log(user)
    form.setValues({
      avatar: null,
      first_name: user.user.first_name || "",
      last_name: user.user.last_name || "",
      user_type: user.user.user_type || 0,
      company: user.user.company || "",
      job_title: user.user.job_title || "",
      year_of_experience: user.user.year_of_experience || 0,
      work_type: user.user.work_type || "",
      university: user.user.university || "",
      degree: user.user.degree || "",
      country: user.user.address?.country || "",
      city: user.user.address?.city || "",
      about_me: user.user.about_me || "",
      expert_in: user.user.expert_in || [],
      skills: user.user.skills || [],
      industries: user.user.industries || [],
      github: user.user.github || "",
      twitter: user.user.twitter || "",
      linkedin: user.user.linkedin || "",
      public_email: user.user.public_email || "",
      public_phone: user.user.public_phone || "",
      display_email: user.user.display_email,
      display_phone: user.user.display_phone,
    });
  }, [user.user]);

  return (
    <Profile
      isEditMode={isEditMode}
      setIsEditMode={setIsEditMode}
      form={form}
    />
  );
}